export default {
  path: 'meta-data',
  name: 'publisher/meta-data',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "publisher-show-metadata" */ './MetaData')
}
